module.exports = __webpack_public_path__ + "Roboto-Medium.fc78759e93a6cac50458.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Medium.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-Medium.woff
// module chunks = 29